export const shapeName = 'TSAiUsageItem';
/**
 * Schema for AI usage item tracking token consumption by service and model.
 * Matches the AiUsageItem type from @takeshape/util.
 */
export const schema = {
    title: shapeName,
    type: 'object',
    description: 'Token usage breakdown for a single service and model',
    properties: {
        service: {
            type: 'string',
            description: 'The AI service provider (e.g., "openai", "anthropic")'
        },
        model: {
            type: 'string',
            description: 'The model identifier (e.g., "gpt-4", "claude-3-opus")'
        },
        inputTokens: {
            type: 'number',
            description: 'Number of input/prompt tokens consumed'
        },
        outputTokens: {
            type: 'number',
            description: 'Number of output/completion tokens generated'
        },
        totalTokens: {
            type: 'number',
            description: 'Total tokens (input + output)'
        },
        reasoningTokens: {
            type: 'number',
            description: 'Number of reasoning tokens used (for models that support extended thinking)'
        },
        cachedInputTokens: {
            type: 'number',
            description: 'Number of input tokens that were served from cache'
        },
        guardrailUnits: {
            type: 'number',
            description: 'Number of guardrail units consumed'
        }
    },
    required: ['service', 'model'],
    additionalProperties: false
};
